export const REASONS_ORDER = [
    'animal_welfare',
    'pornography',
    'violence',
    'clips_copyright',
    'hate',
    'misinformation',
    'bullying_harassment',
    'threatening_stalking',
    'private_information',
    'terrorism',
    'illegal_activity',
    'spam',
    'self_harm',
    'underage_user',
    'graphic_medical_content',
    'disasters_tragedies',
    'coordinated_harm',
    'csam',
    'illegal_substances',
]

export const REASONS_DESCRIPTION = {
    animal_welfare: 'Animal welfare',
    pornography: 'Pornography/Nudity',
    violence: 'Violence',
    hate: 'Hate',
    misinformation: 'Misinformation',
    bullying_harassment: 'Bullying and harassment',
    threatening_stalking: 'Threatening or stalking',
    private_information: 'Includes private information',
    terrorism: 'Terrorism and violent extremists',
    illegal_activity: 'Illegal content: Illegal activity',
    spam: 'Spam',
    self_harm: 'Promoting self-harm',
    underage_user: 'Underage user',
    graphic_medical_content: 'Graphic medical content',
    disasters_tragedies: 'Disasters and tragedies',
    clips_copyright: 'Clips Copyright',
    coordinated_harm: 'Coordinated harm or threat to life',
    csam: 'CSAM',
    illegal_substances: 'Illegal content: Selling illegal substances/service',
}
